import { getApplicationDisplayName, getApplicationIcon } from '@frontend/functionality/utils';
import { CommonMessage } from '@frontend/lang';
import { useState } from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';

import { KioskNavigationHeader } from '../../components/kiosk-navigation-header.component';
import { useKioskNavigate } from '../../utils/kiosk-navigation';
import type { ManageOverviewApplication, ManageOverviewPage } from './manage-overview.controller';
import useManageOverview from './manage-overview.controller';

interface OverviewApplicationListItemProps {
    app: ManageOverviewApplication;
}

const OverviewApplicationListItem = (props: OverviewApplicationListItemProps) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const navigate = useKioskNavigate();
    const { app } = props;

    const name = app.nameOverride ?? getApplicationDisplayName(app.licensedApplication);
    const Icon = getApplicationIcon(app.licensedApplication);

    const onToggle = () => setIsExpanded(!isExpanded);
    return (
        <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
            <div className='flex items-center justify-between self-stretch'>
                <div className='flex items-center justify-start gap-2'>
                    <div className={`bg-brand-${app.type} flex size-6 items-center justify-center rounded-sm`}>
                        <Icon className='text-background-surface size-4' />
                    </div>

                    <div className='text-foreground-default justify-start text-base font-semibold'>{name}</div>
                </div>
                <button
                    type='button'
                    className='size-5 cursor-pointer border-0 bg-transparent p-0'
                    onClick={onToggle}
                    aria-expanded={isExpanded}
                    aria-label={isExpanded ? 'Collapse section' : 'Expand section'}>
                    {isExpanded ? <LuChevronUp size='100%' /> : <LuChevronDown size='100%' />}
                </button>
            </div>
            {isExpanded && (
                <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                    {app.pages.map((page: ManageOverviewPage) => (
                        <div
                            key={page.route}
                            className='bg-background-surface border-border-default flex cursor-pointer items-center justify-start gap-3 self-stretch rounded-xl border p-3'
                            onClick={() => navigate(page.route)}>
                            <div className='text-foreground-default justify-end text-base font-medium'>{page.title}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const ManageOverview = () => {
    const viewProps = useManageOverview();
    const navigate = useKioskNavigate();

    return (
        <div className='bg-background-default flex size-full flex-col items-center justify-start overflow-hidden'>
            <KioskNavigationHeader
                title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)}
                onBack={() => navigate('/')}
            />
            <div className='flex size-full flex-col items-start justify-start gap-6 overflow-hidden p-6'>
                {viewProps.filteredApplications.map((app: ManageOverviewApplication) => (
                    <OverviewApplicationListItem
                        key={app.licensedApplication}
                        app={app}
                    />
                ))}
            </div>
        </div>
    );
};

export default ManageOverview;
